import React from 'react';
import { trackAddToCart } from '../../lib/metaPixel';
interface CTAButtonProps {
  text: string;
  subtext?: string;
  href?: string;
  className?: string;
}
export const CTAButton: React.FC<CTAButtonProps> = ({
  text,
  subtext,
  href = 'https://www.clickdigitalsource.com/cart/43083997642961:1',
  className = ''
}) => {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    // Fire AddToCart event; do not block navigation
    try {
      trackAddToCart();
    } catch (err) {
      // Silent fail — never block checkout flow
    }
  };
  return <a href={href} onClick={handleClick} className={`block w-full bg-green-600 hover:bg-green-500 text-white text-center rounded-xl transition-all transform hover:scale-[1.02] shadow-[0_0_30px_rgba(22,163,74,0.2)] border border-green-500/50 ${className}`} data-id="element-426">
      <div className="py-4 px-6 sm:py-5 sm:px-8" data-id="element-427">
        <span className="block font-bold text-lg sm:text-xl md:text-2xl leading-tight" data-id="element-428">
          {text}
        </span>
        {subtext && <span className="block text-green-100 text-sm sm:text-base mt-1 font-medium" data-id="element-429">
            {subtext}
          </span>}
      </div>
    </a>;
};